import { DownloadOutlined, FilePdfOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { PropsEntity } from "../../../common/entity/props.entity";
import { FilesEntity } from "../entity/files.entity";

export const FileLine = (props: PropsEntity) => {
	const [info, setInfo] = useState<FilesEntity>({});

	useEffect(() => {
		setInfo(props.value);
	}, [props.value]);

	return (
		<Container>
			<div className="title">
				<FilePdfOutlined style={{ color: "red", fontSize: '2rem' }} />
				<div>{info.title}</div>
			</div>
			<div>PDF</div>
			<div>{info.size}</div>
			<div className='download'>
				<a href={info.url} target="_blank" rel="noreferrer" ><DownloadOutlined style={{ color: "white", fontSize: '2rem' }} /></a>
			</div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;
	display: flex;
	height: 2.5rem;
	line-height: 2.5rem;
	background-color: #f0f1f0;
	justify-content: space-between;
    font-weight: 400;
    font-size: 1.1rem;
    margin-bottom: .7rem;

    .title {
        display: flex;
        padding-left: .5rem;
        vertical-align: middle;
		min-width: 40%;

        div {
            padding-left: .5rem;
        }

        span {
            padding-top: .25rem;
        }
    }

	.download {
		background-color: #004885;
        padding: 0 1rem;
        vertical-align: middle;
	}
`;
